import QueryString from 'query-string';
import { useLocation } from 'react-router-dom';

export default function IsHavenCampaign() {
  let location = useLocation();
  const queryString = QueryString.parse(location.search);
  const landingTerm = document.location.pathname.toLowerCase() === '/landing/term';
  const havenCampaign = queryString['haven'] === 'true' && landingTerm;

  return havenCampaign;
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Term/HavenCampaign.js